import { useEffect } from "react";
import { BrowserRouter, useLocation } from "react-router-dom";
import { AppRoutes } from "./router";
import { I18nextProvider } from "react-i18next";
import i18n from "./i18n";
import MusicPlayer from "./pages/home/components/MusicPlayer";

function PersistentMusicPlayer() {
  const location = useLocation();
  if (location.pathname.startsWith('/admin')) return null;
  return <div className={`ys-player-wrap persistent-player ${location.pathname === '/' ? 'persistent-player-home' : 'persistent-player-internal'}`}><MusicPlayer /></div>;
}

function ScrollToHash() {
  const location = useLocation();

  useEffect(() => {
    if (!location.hash) return;
    const target = location.hash.slice(1);
    const timer = window.setTimeout(() => {
      document.getElementById(target)?.scrollIntoView({ behavior: "smooth", block: "start" });
    }, 80);
    return () => window.clearTimeout(timer);
  }, [location.pathname, location.hash]);

  return null;
}

function ContextMenuGuard() {
  useEffect(() => {
    const preventContextMenu = (event: MouseEvent) => event.preventDefault();
    document.addEventListener('contextmenu', preventContextMenu);
    return () => document.removeEventListener('contextmenu', preventContextMenu);
  }, []);
  return null;
}


function App() {
  return (
    <I18nextProvider i18n={i18n}>
      <BrowserRouter basename={__BASE_PATH__}>
        <ScrollToHash />
        <ContextMenuGuard />
        <PersistentMusicPlayer />
        <AppRoutes />
      </BrowserRouter>
    </I18nextProvider>
  );
}

export default App;
